var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"trigger"},[_vm._t("default")],2),_c('div',{class:['tooltip', _vm.position]},[_c('Typography',{attrs:{"variant":"caption","component":"p"}},[_vm._v(_vm._s(_vm.titleSliced))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }